import axios from 'axios';
const deleteAuthToken = () => {
  delete axios.defaults.headers.common['Authorization'];
};
export { deleteAuthToken as default };
